import { render, staticRenderFns } from "./MatchFileAttaching.vue?vue&type=template&id=8ff8ae2e&scoped=true&"
import script from "./MatchFileAttaching.vue?vue&type=script&lang=js&"
export * from "./MatchFileAttaching.vue?vue&type=script&lang=js&"
import style0 from "./MatchFileAttaching.vue?vue&type=style&index=0&id=8ff8ae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff8ae2e",
  null
  
)

export default component.exports